module.exports = __webpack_public_path__ + "static/media/news6-1.f30f701e.jpg";